import React from "react";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { ErrorTableReport } from "../../../Interfaces/orderInterfaces";
import { CommonTableUI } from "../../TableTemplate/common";

const FileBulkOrderTableUI: React.FC<ITableUI<ErrorTableReport>> = ({
  reports,
}: ITableUI<ErrorTableReport>) => {
  return <CommonTableUI reports={reports} />;
};

export default FileBulkOrderTableUI;
